import './entry-received.scss';
import { MessageComponent } from '../../components/message';

export const EntryReceived = () => {
  return <MessageComponent message={'THANK YOU FOR ENTERING'} />;
};
